var map = {
	"./button.svg": "./src/assets/icons/svg/button.svg",
	"./cascader.svg": "./src/assets/icons/svg/cascader.svg",
	"./checkbox.svg": "./src/assets/icons/svg/checkbox.svg",
	"./circle.svg": "./src/assets/icons/svg/circle.svg",
	"./city.svg": "./src/assets/icons/svg/city.svg",
	"./color.svg": "./src/assets/icons/svg/color.svg",
	"./component.svg": "./src/assets/icons/svg/component.svg",
	"./date-range.svg": "./src/assets/icons/svg/date-range.svg",
	"./date.svg": "./src/assets/icons/svg/date.svg",
	"./dept-select.svg": "./src/assets/icons/svg/dept-select.svg",
	"./divider.svg": "./src/assets/icons/svg/divider.svg",
	"./double-loop.svg": "./src/assets/icons/svg/double-loop.svg",
	"./eye-open.svg": "./src/assets/icons/svg/eye-open.svg",
	"./eye.svg": "./src/assets/icons/svg/eye.svg",
	"./green.svg": "./src/assets/icons/svg/green.svg",
	"./horizontal-input.svg": "./src/assets/icons/svg/horizontal-input.svg",
	"./image-carousel.svg": "./src/assets/icons/svg/image-carousel.svg",
	"./image-select.svg": "./src/assets/icons/svg/image-select.svg",
	"./image-upload.svg": "./src/assets/icons/svg/image-upload.svg",
	"./image.svg": "./src/assets/icons/svg/image.svg",
	"./input.svg": "./src/assets/icons/svg/input.svg",
	"./like.svg": "./src/assets/icons/svg/like.svg",
	"./line.svg": "./src/assets/icons/svg/line.svg",
	"./loginQQ.svg": "./src/assets/icons/svg/loginQQ.svg",
	"./map.svg": "./src/assets/icons/svg/map.svg",
	"./matrix-input.svg": "./src/assets/icons/svg/matrix-input.svg",
	"./matrix-scale.svg": "./src/assets/icons/svg/matrix-scale.svg",
	"./matrix-select.svg": "./src/assets/icons/svg/matrix-select.svg",
	"./message.svg": "./src/assets/icons/svg/message.svg",
	"./message_default.svg": "./src/assets/icons/svg/message_default.svg",
	"./mobile.svg": "./src/assets/icons/svg/mobile.svg",
	"./nps.svg": "./src/assets/icons/svg/nps.svg",
	"./number.svg": "./src/assets/icons/svg/number.svg",
	"./ocr.svg": "./src/assets/icons/svg/ocr.svg",
	"./page.svg": "./src/assets/icons/svg/page.svg",
	"./password.svg": "./src/assets/icons/svg/password.svg",
	"./radio.svg": "./src/assets/icons/svg/radio.svg",
	"./rate.svg": "./src/assets/icons/svg/rate.svg",
	"./rich-text.svg": "./src/assets/icons/svg/rich-text.svg",
	"./row.svg": "./src/assets/icons/svg/row.svg",
	"./select.svg": "./src/assets/icons/svg/select.svg",
	"./sign-pad.svg": "./src/assets/icons/svg/sign-pad.svg",
	"./slider.svg": "./src/assets/icons/svg/slider.svg",
	"./sort.svg": "./src/assets/icons/svg/sort.svg",
	"./star.svg": "./src/assets/icons/svg/star.svg",
	"./start.svg": "./src/assets/icons/svg/start.svg",
	"./sub-form.svg": "./src/assets/icons/svg/sub-form.svg",
	"./switch.svg": "./src/assets/icons/svg/switch.svg",
	"./table.svg": "./src/assets/icons/svg/table.svg",
	"./text.svg": "./src/assets/icons/svg/text.svg",
	"./textarea.svg": "./src/assets/icons/svg/textarea.svg",
	"./time-range.svg": "./src/assets/icons/svg/time-range.svg",
	"./time.svg": "./src/assets/icons/svg/time.svg",
	"./upload.svg": "./src/assets/icons/svg/upload.svg",
	"./user-select.svg": "./src/assets/icons/svg/user-select.svg",
	"./yellow.svg": "./src/assets/icons/svg/yellow.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";